import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {NetInfoState, NetInfoStateType} from '@react-native-community/netinfo';

export interface NetInfoStateCustom {
  isInternetReachable: boolean | null | undefined;
  isConnected: boolean | null;
  type: NetInfoStateType;
  isDetected: boolean;
  hasTrackedRequestError: boolean;
}

const initialState: NetInfoStateCustom = {
  isInternetReachable: false,
  isConnected: false,
  hasTrackedRequestError: false,
  type: NetInfoStateType.unknown,
  isDetected: false,
};

export const netInfoSlice = createSlice({
  name: '@@eskso/httpWrapper/netInfo',
  initialState,
  reducers: {
    reset: () => initialState,
    setError: (state, action: PayloadAction<boolean>) => {
      state.hasTrackedRequestError = action.payload;
    },
    setState: (state, action: PayloadAction<NetInfoState>) => {
      state.isInternetReachable = action.payload.isInternetReachable;
      state.isConnected = action.payload.isConnected;
      state.type = action.payload.type;
      state.isDetected = true;
    },
  },
});
